import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Modal, Table } from 'react-bootstrap';
import WareHouseForm from './WareHouseForm';
import axios from 'axios';

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function WareHouse() {
  const [view, setView] = useState('list');
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const fetchWarehouses = () => {
    axios.get(`${BASE_URL}/warehouses`)
      .then((response) => setWarehouses(response.data))
      .catch((error) => console.error('Error fetching warehouses:', error));
  };

  const handleDeleteWarehouse = (id) => {
    axios.delete(`${BASE_URL}/warehouses/${id}`)
      .then(() => {
        setWarehouses(warehouses.filter((warehouse) => warehouse.id !== id));
        setShowDeleteModal(false);
      })
      .catch((error) => console.error('Error deleting warehouse:', error));
  };

  const renderContent = () => {
    if (view === 'list') {
      return (
        <div className='p-4'>
          <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
            <h3>WareHouse List</h3>
            <Button variant="primary" onClick={() => setView('add')}>Add New</Button>
          </div>
          <Table striped bordered hover responsive className='mb-5 mt-2'>
            <thead>
              <tr>
                <th>Sr.no</th>
                <th>WareHouse Name</th>
                <th>Address</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {warehouses.map((warehouse, index) => (
                <tr key={warehouse.id}>
                  <td>{index + 1}</td>
                  <td>{warehouse.name}</td>
                  <td>{warehouse.address}</td>
                  <td>{warehouse.ip}</td>
                  <td>
                    <div className="d-flex justify-content-end align-reports-center gap-4 p-1">
                      <Dropdown>
                        <Dropdown.Toggle variant="primary">Actions</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item className='text-success' onClick={() => { setSelectedWarehouse(warehouse); setView('edit'); }}>Edit</Dropdown.Item>
                          <Dropdown.Item className='text-danger' onClick={() => { setSelectedWarehouse(warehouse); setShowDeleteModal(true); }}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      );
    }

    if (view === 'add' || view === 'edit') {
      return <WareHouseForm registerTag={view === 'edit' ? selectedWarehouse : null} onCancel={() => setView('list')} onSave={onSave} />;
    }

    return null;
  };

  const onSave = (newWarehouseData) => {
    fetchWarehouses();
    setView('list');
  };

  return (
    <div>
      {renderContent()}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this item?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={() => handleDeleteWarehouse(selectedWarehouse.id)}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default WareHouse;
